/* unplugin-vue-components disabled */import { render } from "./w-tooltip.vue?vue&type=template&id=7ab99b1b&ts=true"
import script from "./w-tooltip.vue?vue&type=script&lang=ts"
export * from "./w-tooltip.vue?vue&type=script&lang=ts"

import "./w-tooltip.vue?vue&type=style&index=0&id=7ab99b1b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__